import React from 'react';

import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import IconEmail from '@material-ui/icons/EmailOutlined';
import IconPhone from '@material-ui/icons/PhoneOutlined';
import IconPin from '@material-ui/icons/PlaceOutlined';

import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockLocations } from '../types/_blocks.types';
import { normaliseUrl } from '../utils/url';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
  locationAddress: {
    minHeight: 60,
    display: 'flex',
    alignItems: 'center',
  },
}));

type Props = BlockBuilder<BlockLocations>;

export const LocationsBlock: React.FC<Props> = ({ block, getImageData }) => {
  const { title, content, items } = block;
  const classes = useBlockStyles(useStyles, block);
  const filledLocations = items.filter(
    (item) => !!item.title && item.title !== '$',
  );
  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ paddingBottom: '1rem' }}>
            <Typography variant="h3">{title}</Typography>
          </Grid>
          <Grid item xs={12} style={{ padding: '1rem' }}>
            <Typography variant="body1">{content}</Typography>
          </Grid>
          {filledLocations.map((item) => (
            <Grid key={item.id} item xs={12} sm={6} lg={3}>
              <Card>
                <CardContent>
                  <Link href={normaliseUrl(item?.cta?.link ?? '/')}>
                    <Typography variant="h6">{item.title}</Typography>
                  </Link>
                  <List dense={true}>
                    <ListItem>
                      <ListItemIcon>
                        <IconPin />
                      </ListItemIcon>
                      <ListItemText>
                        <ListItemText className={classes.locationAddress}>
                          <Typography variant="body2">
                            {item.address}
                          </Typography>
                        </ListItemText>
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconPhone />
                      </ListItemIcon>
                      <ListItemText>
                        <ListItemText>
                          <Typography variant="body2">{item.phone}</Typography>
                        </ListItemText>
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconEmail />
                      </ListItemIcon>
                      <ListItemText>
                        <ListItemText>
                          <Typography variant="body2">{item.email}</Typography>
                        </ListItemText>
                      </ListItemText>
                    </ListItem>
                  </List>
                </CardContent>
                <CardMedia
                  className={classes.media}
                  image={getImageData(item.image)?.images.fallback?.src}
                  title="Location Map"
                  style={{ height: 200, width: 'auto' }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
